



































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import EmptyData from '../../../EmptyData/EmptyData.vue'
import ListGroup from './components/ListGroup.vue'
import ListItemView from './components/ListItemView.vue'
import { Entity, ListConfig, SearchFn, Group as GroupType } from './logic/types'

@Component({
  components: {
    ListItemView,
    ListGroup,
    EmptyData,
  },
})
export default class DefaultList extends Vue {
  @Prop() readonly config!: ListConfig

  @Watch('config.data', { immediate: true })
  onDataChange(val: any) {
    this.mainList = this.config.data
  }

  searchText = ''

  mainList: any = []

  searchInputClasses: Array<string> = []

  get selectFn(): any | undefined {
    return this.config.selectFn
  }

  get searchFn(): SearchFn {
    return this.config.searchFn ? this.config.searchFn : this.defaultSearchFn
  }

  get showTopBar(): boolean {
    return this.$slots.title !== undefined || this.searchFn !== undefined
  }

  get emptyListData(): { 'icon': string, 'text': string } {
    if (this.searchText !== '') {
      return { icon: 'not-found', text: this.$t('pi_list_not_found') as string }
    }

    return { icon: 'list-empty', text: this.$t('pi_list_empty') as string }
  }

  @Watch('searchText')
  searchTextWatcher(value: string): void {
    this.mainList = value.length ? this.searchFn(this.config.data, value) : this.config.data
  }

  defaultSearchFn(list: Array<Entity>, searchText: string): Array<Entity> {
    const newDataList: Array<Entity> = []

    for (const dataItem of list) {
      if (dataItem.group) {
        this.searchInGroups(searchText, dataItem, newDataList)
      } else if (dataItem.items) {
        this.searchInItems(searchText, dataItem, newDataList)
      }
    }

    return newDataList
  }

  searchInItems(searchText: string, dataItem: any, newDataList: Array<Entity>): void {
    for (const iterationItem of dataItem.items) {
      if (iterationItem.title.toLowerCase().includes(searchText.toLowerCase().trim())) {
        let itemsList = newDataList.find((itemsList: Entity) => itemsList.items)
        if (!itemsList) {
          newDataList.push({ items: [] })
          itemsList = newDataList.find((itemsList: Entity) => itemsList.items)
        }
        itemsList?.items?.push(iterationItem)
      }
    }
  }

  searchInGroups(searchText: string, dataItem: any, newDataList: Array<Entity>): void {
    for (const groupItem of (dataItem.group as GroupType).groupItems) {
      if (groupItem.title.toLowerCase().includes(searchText.toLowerCase().trim())) {
        const findItem = newDataList.find((dataListGroup: Entity) => dataListGroup.group && dataListGroup.group?.titleKey === dataItem.group?.titleKey)
        findItem ? findItem.group?.groupItems.push(groupItem) : newDataList.push({
          group: {
            titleKey: dataItem.group.titleKey,
            guid: dataItem.group.guid,
            groupItems: [ { ...groupItem } ],
          },
        })
      }
    }
  }

  created(): void {
    this.mainList = this.config.data

    this.$i18n.mergeLocaleMessage('ru', {
      pi_list_empty: 'Список пуст',
      pi_list_not_found: 'Не найдено',
      field_search_text_placeholder: 'Поиск',
    })
    this.$i18n.mergeLocaleMessage('en', {
      pi_list_empty: 'List is empty',
      pi_list_not_found: 'Not found',
      field_search_text_placeholder: 'Search',
    })
  }
}
